var productArray = [];
 
productArray.push({
	sku: pers_product_sku,
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: pers_textSize,
			yB: pers_textPosition.yb, //Left top corner (Vert)
			xL: pers_textPosition.xl, //Left top corner (Hor)
			yT: pers_textPosition.yt, //Right Bottom corner (Vert)
			xR: pers_textPosition.xr, //Right Bottom corner (Hor)
			bespokeValue: pers_defaultText,
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: pers_textColour,
			lineHeight: 260
		}
	]
});


productArray.push({
	sku: "MILO022_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 372,
            xR: 660,
			yT: 280,
            yB: 315,
			bespokeValue: "Lola", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#e83a89",
			lineHeight: 260
		},
        {
			originalFontSize: 55,
			xL: 523,
            xR: 613,
			yT: 377,
            yB: 407,
			bespokeValue: "2017",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#55b156",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});


productArray.push({
	sku: "MILO023_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 372,
            xR: 660,
			yT: 280,
            yB: 315,
			bespokeValue: "Izzy", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#4CBDC8",
			lineHeight: 260
		},
        {
			originalFontSize: 55,
			xL: 520,
            xR: 615,
			yT: 380,
            yB: 413,
			bespokeValue: "2017",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364898",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO024_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 368,
            xR: 655,
			yT: 290,
            yB: 330,
			bespokeValue: "Oliver", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#F3A238",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO025_TSHIRT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 381,
            xR: 645,
			yT: 295,
            yB: 340,
			bespokeValue: "Penelope", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364998",
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO039_BABYGROW",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 356,
            xR: 668,
			yT: 270,
            yB: 370,
			bespokeValue: "Thomas", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#4CBDC8",
			lineHeight: 260
		},
        {
			originalFontSize: 55,
			xL: 525,
            xR: 620,
			yT: 375,
            yB: 475,
			bespokeValue: "2022",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364898",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO038_BABYGROW",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 356,
            xR: 668,
			yT: 270,
            yB: 370,
			bespokeValue: "Amelia", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#e83a89",
			lineHeight: 260
		},
        {
			originalFontSize: 55,
			xL: 525,
            xR: 620,
			yT: 375,
            yB: 475,
			bespokeValue: "2022",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#55b156",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO040_BABYGROW",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
			xL: 356,
            xR: 668,
			yT: 270,
            yB: 370,
			bespokeValue: "Oscar", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#F3A238",
			lineHeight: 260
		}
	]
});
productArray.push({
	sku: "MILO041_BABYGROW",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 70,
            xL: 380,
            xR: 668,
			yT: 270,
            yB: 370,
			bespokeValue: "Penelope", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364998",
			lineHeight: 260
		}
	]
});





productArray.push({
	sku: "MILO026_BIB",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 100,
			xL: 300,
            xR: 740,
			yT: 530,
            yB: 630,
			bespokeValue: "Sophie", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#E83A89",
			lineHeight: 260
		},
        {
			originalFontSize: 60,
			xL: 535,
            xR: 645,
			yT: 700,
            yB: 750,
			bespokeValue: "2022",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#55b156",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO027_BIB",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 100,
			xL: 285,
            xR: 725,
			yT: 530,
            yB: 630,
			bespokeValue: "Lucas", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#4CBDC8",
			lineHeight: 260
		},
        {
			originalFontSize: 70,
			xL: 515,
            xR: 640,
			yT: 700,
            yB: 740,
			bespokeValue: "2022",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364898",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});


productArray.push({
	sku: "MILO030_BLNKT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 100,
			xL: 220,
            xR: 805,
			yT: 347,
            yB: 440,
			bespokeValue: "Sophie", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#e83a89",
			lineHeight: 260
		},
        {
			originalFontSize: 70,
			xL: 540,
            xR: 710,
			yT: 577,
            yB: 630,
			bespokeValue: "2022",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#55b156",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});


productArray.push({
	sku: "MILO031_BLNKT",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 100,
			xL: 210,
            xR: 825,
			yT: 340,
            yB: 445,
			bespokeValue: "Thomas", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#4CBDC8",
			lineHeight: 260
		},
        {
			originalFontSize: 70,
			xL: 510,
            xR: 718,
			yT: 570,
            yB: 640,
			bespokeValue: "2022",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364898",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});


productArray.push({
	sku: "MILO034_WTRBTL",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 80,
			xL: 400,
            xR: 630,
			yT: 530,
            yB: 620,
			bespokeValue: "Lola", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#E83A89",
			lineHeight: 260
		},
        {
			originalFontSize: 70,
			xL: 523,
            xR: 624,
			yT: 769,
            yB: 806,
			bespokeValue: "2018",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#54b156",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});

productArray.push({
	sku: "MILO035_WTRBTL",
	canvasHeight: 1024,
	canvasWidth: 1024,
	text: [
		{
			originalFontSize: 80,
			xL: 409,
            xR: 625,
			yT: 550,
            yB: 630,
			bespokeValue: "Izzy", 
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#4cbdc8",
			lineHeight: 260
		},
        {
			originalFontSize: 70,
			xL: 522,
            xR: 624,
			yT: 764,
            yB: 801,
			bespokeValue: "2018",
			caseRule: "uppercase",
			horizontalAlignment: "center",
			fontFamilyBase: 'Papercute',
			primaryFontColor: "#364998",
            customTextInput: 'year',
			//customTextOutput: 'year',
			lineHeight: 260
		}
	]
});
